module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/SRI91TG5Czoj35r5ZSzRJ-78eee31a6faa2a53f63bed49bed99c39.jpg";